import { ReactElement } from "react";
import { toast } from "react-toastify";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
} from "@fortawesome/pro-light-svg-icons";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { CloseButton } from "./close-button/close-button";
import ToastTypes from "./toast-types.json";

import "react-toastify/dist/ReactToastify.min.css";
import "./toast.scss";

type statusTypes = typeof ToastTypes[keyof typeof ToastTypes];

export interface ToastOptions {
  type: statusTypes;
  closeButton: boolean;
  closeButtonTitle: string;
  icon?: IconDefinition;
}

const buildToast = (
  content: string | ReactElement,
  status: statusTypes,
  customIcon?: IconDefinition,
): ReactElement => {
  const ICONS = new Map([
    [ToastTypes.success, faCheckCircle],
    [ToastTypes.error, faBan],
    [ToastTypes.warning, faExclamationTriangle],
    [ToastTypes.info, faInfoCircle],
  ]);

  const icon = customIcon || ICONS.get(status);

  return (
    <div className={`toast__wrapper toast--${status}`}>
      <FontAwesomeIcon className="toast__icon" icon={icon as IconProp} />
      <div className="toast__content-wrapper">{content}</div>
    </div>
  );
};

export default function Toast(
  content: string | ReactElement = "",
  options: ToastOptions = {
    type: ToastTypes.info,
    closeButton: true,
    closeButtonTitle: "Dismiss toast",
  },
): void {
  toast(buildToast(content, options.type, options.icon), {
    className: `toast--${options.type}`,
    closeButton: options.closeButton && (
      <CloseButton
        className={`toast--${options.type}`}
        title={options.closeButtonTitle}
      />
    ),
  });
}
